<script setup lang="ts"></script>
<template>
  <!--
  Used to render buttons in the footer of a ModalCard. If possible use ModalFormButtons.vue.
  If not, use this component to wrap the content so that the layout is always the same
  -->
  <div class="flex w-full justify-between">
    <div
      v-if="$slots['aside']"
      data-test-id="modal-aside"
      class="shrink-0 justify-self-start"
    >
      <slot name="aside" />
    </div>
    <div
      class="flex w-full flex-wrap justify-end gap-1 md:gap-2"
      data-test-id="modal-body"
    >
      <slot />
    </div>
  </div>
</template>
